<template>
<CContainer class="p-0">
    <CRow>
        <CCol col="12" sm="9" class="mx-auto">
            <CCard class="shadow-sm">
                <CCardBody>
                    <CRow class="pb-2">
                        <CCol col="12">
                            <ImageProfile class="d-block d-sm-inline-block mfe-sm-2 p-sm-2 logo mx-auto" :src="store.logo" :alt="store.name" />
                            <div class="d-block text-center text-sm-right d-sm-inline-block mfs-sm-2 mt-3 mt-sm-0">
                                <h6>{{ store.name }}</h6>
                                <a dir="ltr" :href="storeWebsite" target="_blank">{{ store.website }}</a>
                                <small class="d-block">
                                    {{ store.category && store.category.title }}
                                </small>
                            </div>
                        </CCol>
                    </CRow>

                    <p class="border-top pt-2" v-html="store.description"></p>

                    <CButton
                        class="font-xs btn-sm join-to-store"
                        color="affili-indigo"
                        v-if="canJoin()"
                        :data-store-name="store.name"
                        @click="joinModal = {item: store, show: true, desc: '', err_msg: ''}"
                    >{{ store.user_rel_status === StoreUserRelationStatus.REJECTED ? $t('store.join_again') : $t('store.join') }}</CButton>

                    <span class="alert alert-success d-block mb-0" v-if="store.user_rel_status === StoreUserRelationStatus.ACTIVE">شما در حال همکاری با این فروشگاه هستید.</span>
                    <span class="alert alert-warning d-block mb-0" v-if="store.user_rel_status === StoreUserRelationStatus.PENDING">درخواست همکاری شما در انتظار تایید مدیر فروشگاه است.</span>
                    <span class="alert alert-danger d-block mb-0 mt-3" v-if="store.user_rel_status === StoreUserRelationStatus.REJECTED">
                        <span class="d-block">درخواست همکاری شما به دلیل زیر رد شد.</span>
                        <span class="bg-gray-200 text-dark p-2 d-block mt-2 rounded">{{ stopWorkingResult }}</span>
                    </span>
                </CCardBody>
            </CCard>
            <table class="table table-bordered bg-white shadow-sm">
                <thead>
                    <tr>
                        <th width="33%" scope="col">
                            <small class="font-2xl font-weight-bold">{{ store.cookie_lifetime }} {{ $t('time.day') }}</small>
                            <br>
                            <small>{{ $t('store.cookie_period') }}</small>
                        </th>
                        <th width="33%" scope="col">
                            <small class="font-2xl font-weight-bold">{{ store.conversion_locked_after }} {{ $t('time.day') }}</small>
                            <br>
                            <small>{{ $t('store.conversion_locked_after') }}</small>
                        </th>
                        <th width="33%" scope="col">
                            <small class="font-2xl font-weight-bold">{{ store.members_count }}</small>
                            <br>
                            <small>{{ $t('publisher.plural') }}</small>
                        </th>
                    </tr>
                </thead>
            </table>
        </CCol>


        <CCol col="12" sm="9" class="mx-auto">
            <CTabs>
                <CTab>
                    <template #title>
                        <FaIcon icon="percentage" class="d-none d-sm-inline-block text-affili-eggplant icon" />
                        <span class="text-dark mfs-2">{{ $t('commission.plural')}}</span>
                    </template>
                    <CommissionsTableV2 v-if="Object.keys(commissionsV2).length > 0" />
                    <CommissionsTable v-else class="table-component px-3" />
                </CTab>

                <CTab v-if="promotionsCount > 0">
                    <template #title>
                        <FaIcon icon="ad" class="d-none d-sm-inline-block text-affili-cerise icon" />
                        <span class="text-dark mfs-2">{{ $t('promotion.types_plural.banner')}}</span>
                    </template>
                    <Grid gridClasses="bg-white pt-4 mx-3" />
                </CTab>
            </CTabs>
        </CCol>
    </CRow>

    <CModal :show.sync="joinModal.show">
        <template #header-wrapper>
            <span></span>
        </template>

        <span class="alert alert-warning d-block">
            درخواست شما توسط صاحب فروشگاه بررسی می‌شود و درصورت تایید می‌توانید اقدام به همکاری با فروشگاه کنید.
        </span>

        <span>
            در چند خط توضیح دهید چرا می‌خواهید با فروشگاه <span class="font-weight-bold">{{ joinModal.item.name }}</span> همکاری کنید. و چرا صاحب فروشگاه باید درخواست همکاری شما را بپذیرد.
        </span>
        <CTextarea class="mb-0" v-model="joinModal.desc" rows="4" />
        <span class="d-block text-left font-xs">50 / {{ joinModal.desc.trim().length }}</span>

        <span class="text-danger font-xs d-block">{{ joinModal.err_msg }}</span>

        <template #footer>
            <CButton @click="joinModal.show = false" color="secondary">{{ $t('cancel') }}</CButton>
            <CButton
                :disabled="joinModal.desc && joinModal.desc.trim().length <= 49"
                @click="joinToStore"
                color="primary"
            >{{ $t('store.join_request') }}</CButton>
        </template>
    </CModal>
</CContainer>
</template>

<script>
import psl from 'psl'
import { mapActions, mapGetters } from 'vuex'
import { Grid } from '@/views/promotions/partials'
import ImageProfile from '@/components/ImageProfile'
import { StoreUserRelationStatus, PromotionType } from '@/constants'
import { Table as CommissionsTable } from '@/views/commissions/partials'
import { Table as CommissionsTableV2 } from '@/views/v2.commissions/partials'

export default {
    name: 'Profile',
    components: {
        CommissionsTable,
        Grid,
        ImageProfile,
        CommissionsTableV2,
    },

    data() {
        return {
            id: this.$route.params.id,
            StoreUserRelationStatus,
            joinModal: {
                item: {},
                show: false,
                desc: ''
            },
            stopWorkingResult: ''
        }
    },

    beforeRouteEnter(to, from, next) {
        next(vm => {
            vm.findStore(vm.id)
            vm.fetchPromotions({
                no_paginate: true,
                store: {
                    id: vm.id
                },
                type: PromotionType.BANNER
            })
            vm.fetchCommissions({
                no_paginate: true,
                store: {
                    id: vm.id
                },
            })
            vm.fetchCommissionsV2({
				no_paginate: true,
				store: {
					id: vm.id
				}
			})

            vm.findRel({
                rel_id: vm.store.user_rel_id,
            }).then(result => {
                vm.stopWorkingResult = result.data.stop_working_result
            })
        })
    },

    computed: {
        ...mapGetters({
            storeById: 'store/storeById',
            promotionsCount: 'promotion/promotionsCount',
            commissions: 'commission/commissions',
            commissionsV2: 'v2commission/commissions'
        }),
        store() {
            return this.storeById(this.id) || {}
        },
        storeWebsite() {
            if(this.store.website) {
                const hostName   = this.extractHostname(this.store.website)
                const domainName = psl.get(hostName)

                return new URL(`http://${domainName}`).toString().toLowerCase()
            }

            return '#'
        }
    },

    methods: {
        ...mapActions({
            findStore: 'store/find',
            fetchCommissions: 'commission/fetch',
            fetchCommissionsV2: 'v2commission/fetch',
            fetchPromotions: 'promotion/fetch',
            join: 'store/join',
            findRel: 'publisher/findByRelId',
        }),
        extractHostname(url) {
            let hostname;
            //find & remove protocol (http, ftp, etc.) and get hostname

            if (url.indexOf("//") > -1) {
                hostname = url.split('/')[2];
            }
            else {
                hostname = url.split('/')[0];
            }

            //find & remove port number
            hostname = hostname.split(':')[0];
            //find & remove "?"
            hostname = hostname.split('?')[0];

            return hostname;
        },
        canJoin() {
            return this.store.user_rel_status === null
                || this.store.user_rel_status === StoreUserRelationStatus.STOP_BY_PUBLISHER
                || this.store.user_rel_status === StoreUserRelationStatus.REJECTED
        },
        joinToStore() {
            this.join({
                id: this.joinModal.item.id,
                request_description: this.joinModal.desc,
            }).then(() => {
                this.joinModal = {item: {}, show: false, desc: '', err_msg: ''}
            }).catch(err => {
                this.joinModal.err_msg = err.data.err_msg
            })
        },
        openRequestModal(store) {
            this.findRel({
                rel_id: store.user_rel_id,
            }).then(result => {
                this.requestModal = {item: result.data, show: true}
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.profile-header {
    margin-bottom: 60px;
    .logo {
        height: auto;
        width: 100%;
        max-width: 90px;
        padding: 2px;
        &.default {
            background-color: #4A148C;
        }
    }
    @media screen and (max-width: 425px) {
        .logo {
            max-width: 50px;
        }
    }
    .store-name {
        text-align: center;

    }
    .profile-logo {
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        background: #fff;
        bottom: -40px;
        padding: 15px;
        border-radius: 15px;
    }
}

.profile-btns {
    margin-top: 2rem;
    a {
        text-decoration: none !important;
        &.disabled{
            cursor: not-allowed;
            .icon {
                color: #768192 !important; // muted
            }
        }
        .icon {
            font-size: 3rem;
        }
    }
}
.table-component::v-deep div.card {
    border-top: 0!important;
    border-radius: 0!important;
}
.logo {
    height: auto;
    width: 100%;
    max-width: 100px;
    padding: 2px;
    border-radius: 5px;
    vertical-align:top;
    &.default {
        background-color: #4A148C;
    }
}
@media screen and (max-width: 425px) {
    .logo {
        max-width: 120px;
    }
}
.nav-item::v-deep .nav-link.active {
    background-color: #fff;
}
</style>
